import type { ReactNode } from 'react';
import { Button, Space } from 'antd';
import type { BoundAction } from '@/shared/lib/hotkeys';
import { HotkeyButton, HotkeyTip } from './hotkey';

export interface EditorFooterProps {
  /** Действие «Сохранить» из `useEditorWindow`: клавиша и причина недоступности — в подсказке. */
  save: BoundAction;
  saving?: boolean;
  /** Закрытие с вопросом о несохранённом (`requestClose`). */
  onRequestClose: () => void;
  /** Кнопки между «Сохранить» и «Закрыть» (например, «В архив»). */
  children?: ReactNode;
}

/** Подвал простого окна-редактора: «Сохранить» (клавиша и причина — в подсказке), свои кнопки,
 *  «Закрыть» (`Esc`). */
export function EditorFooter({ save, saving, onRequestClose, children }: EditorFooterProps) {
  return (
    <Space>
      <HotkeyButton type="primary" loading={saving} action={save}>
        {save.label}
      </HotkeyButton>
      {children}
      <HotkeyTip catalogId="window.close">
        <Button onClick={onRequestClose}>Закрыть</Button>
      </HotkeyTip>
    </Space>
  );
}
